import { reverseBits16 } from "./Bits";

export type TPosition = Uint8Array;
export type TFracList<T> = Map<TPosition, T>;

const MAX_DIGIT_VALUE = 2 ** 8;
const MID_DIGIT_VALUE = MAX_DIGIT_VALUE / 2;
const START_POSITION = new Uint8Array();
const FIRST_POSITION = new Uint8Array([MID_DIGIT_VALUE]);

const END_POSITION = new Proxy(new Uint8Array(), {
  get(target, p, receiver) {
    if (p === "length") {
      return Number.POSITIVE_INFINITY;
    }
    return MAX_DIGIT_VALUE;
  },
});

function positionBetween(a: TPosition, b: TPosition) {
  let i = 0;
  for (; i < Math.min(a.length, b.length); i++) {
    // A: [abc]6[.*]
    // O: [abc]7
    // B: [abc]7[.+]
    if (b[i] - a[i] === 1 && b.length - 1 > i) {
      const out = new Uint8Array(i + 1);
      if (b.length === Number.POSITIVE_INFINITY) {
        out.fill(MAX_DIGIT_VALUE);
      } else {
        out.set(new Uint8Array(b.buffer, 0, i));
      }
      return out;
    }
    // A: [abc]6[.*]
    // O: [abc]7
    // B: [abc]8[.*]
    if (b[i] - a[i] > 1) {
      const mid = (a[i] + b[i]) / 2;
      const out = new Uint8Array(i + 1);
      out.set(new Uint8Array(a.buffer, 0, i));
      out[i] = mid;
      return out;
    }
  }

  for (; i < b.length; i++) {
    // A: [abc]6
    // O: [abc]6[x:0*]05
    // B: [abc]6[x:0*]1[.*]
    if (b[i] === 1) {
      const out = new Uint8Array(i + 1).fill(0, a.length);
      out.set(a);
      out[i] = 0;
      out[i + 1] = MID_DIGIT_VALUE;
      return out;
    }

    // A: [abc]6
    // O: [abc]6[x:0*]1
    // B: [abc]6[x:0*]2[.*]
    if (b[i] > 1) {
      const mid = b[i] / 2;
      const out = new Uint8Array(i + 1).fill(0, a.length);
      out.set(a);
      out[i] = mid;
      return out;
    }
  }

  for (; i < a.length; i++) {
    // A: [abc]6[x:9*]8[.*]
    // O: [abc]6[x:9*]9
    // B: [abc]7
    if (MAX_DIGIT_VALUE - a[i] > 1) {
      const mid = (a[i] + MAX_DIGIT_VALUE) / 2;
      const out = new Uint8Array(i + 1);
      out.set(a);
      out[i] = mid;
      return out;
    }
  }

  // A: [abc]6[x:9*]
  // O: [abc]6[x:9*]5
  // B: [abc]7
  const out = new Uint8Array(a.length + 1);
  out.set(a);
  out[a.length] = MID_DIGIT_VALUE;
  return out;
}

function lastKey(list: TFracList<any>) {
  return list.keys().toArray().pop();
}

// export function positionAtEnd(list: TFracList<any>) {
//   const a = lastKey(list) ?? START_POSITION;
//   for (let i = 0; i < a.length; i++) {
//     // A: 999998
//     // O: 999999
//     // B: 999999...
//     if (a[i] < MAX_DIGIT_VALUE) {
//       const out = new Uint8Array(i + 1);
//       out.set(new Uint8Array(a.buffer, 0, i));
//       out[i] = (a[i] + MAX_DIGIT_VALUE) / 2;
//       return out;
//     }
//   }
//   // A: 99999
//   // O: 999995
//   // B: 999999...
//   const out = new Uint8Array(a.length + 1);
//   out.set(a);
//   out[a.length] = MID_DIGIT_VALUE;
//   return out;
// }

export function positionAtEnd(list: TFracList<any>) {
  if (list.size === 0) {
    return FIRST_POSITION;
  }
  return positionBetween(lastKey(list)!, END_POSITION);
}

export function positionWithWriterId(position: TPosition, id: number) {
  const bytes = new Uint8Array(new ArrayBuffer(position.byteLength + 2));
  const view = new DataView(bytes.buffer);
  bytes.set(position);
  view.setUint16(position.byteLength, reverseBits16(id));
  return bytes;
}

export function insert<T>(list: TFracList<T>, position: TPosition, elem: T) {
  console.log(list, position, elem);
  return new Map(list).set(position, elem);
}

export function createFracList() {
  return new Map();
}
